


































import { Component, Vue, Prop } from "vue-property-decorator";
import QuestionItem from "./QueItem.vue";
@Component({
  components: {
    QuestionItem
  }
})
export default class Question extends Vue {
  @Prop({ required: true }) private list!: any;
  @Prop({}) private ukey!: any;

  handleBtn(key: any) {
    // this.key = key;
    this.$emit("changeUkey", key);
  }
  handleAll() {
    this.$router.push(`/question?type=${this.ukey == "mba" ? 2 : 1}`);
  }
}
